import { PhoneNumber } from './phoneNumber';

const ATE_REGION = 'SK';

export function resolveAtePhoneNumber(
  enteredValue: string | null | undefined,
  dataSentenceValue: string | null | undefined,
): string | null {
  return PhoneNumber.tryInitialize(enteredValue, ATE_REGION)?.value ?? dataSentenceValue ?? null;
}
